/* "Take 15% off." popup (snippets/signup-popup.liquid).
 *
 * Desktop: shows after 6 seconds, 20% scroll, or exit intent. Mobile: after
 * 20 seconds, or on exit intent (quick scroll up) before that. Either way
 * for United States visitors only, at most once per 20 days per browser.
 * Step 1 subscribes the email; step 2 adds a phone number with SMS consent.
 * The only thing stored in the browser is the date the popup may show again
 * (like Omnisend's own "popup closed" cookie); no tracking.
 */
(function () {
  var root = document.getElementById('sg-popup');
  if (!root || window.__sgPopupReady) return;
  window.__sgPopupReady = true;

  var HIDE_KEY = 'sg_popup_hidden_until';
  var DAY = 864e5;
  var SHOW_EVERY_DAYS = 20;
  var AFTER_SIGNUP_DAYS = 365;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var MSG = {
    required: 'This field is required',
    email: 'The email address must contain @ and a valid domain',
    phone: 'Must be valid phone number',
    consent: 'Agree to receive marketing communications to subscribe.',
    failed: 'Something went wrong!',
    processing: 'Processing'
  };

  function hiddenUntil() {
    try { return Number(localStorage.getItem(HIDE_KEY)) || 0; } catch (e) { return 0; }
  }
  function hideFor(days) {
    try { localStorage.setItem(HIDE_KEY, String(Date.now() + days * DAY)); } catch (e) {}
  }

  if (hiddenUntil() > Date.now()) return;

  // Visitors arriving from an Omnisend email are already subscribers.
  var params = new URLSearchParams(location.search);
  var fromOmnisend = /omnisend/i.test(params.get('utm_source') || '') ||
    Array.from(params.keys()).some(function (k) { return /^omnisend/i.test(k); });
  if (fromOmnisend) return;

  var shown = false;
  var checking = false;
  var lastFocus = null;
  var email = '';

  function isUS() {
    var cached;
    try { cached = sessionStorage.getItem('sg_popup_country'); } catch (e) {}
    if (cached) return Promise.resolve(cached === 'US');
    return fetch(root.dataset.geo, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        try { sessionStorage.setItem('sg_popup_country', j.country || '-'); } catch (e) {}
        return j.country === 'US';
      })
      .catch(function () { return false; });
  }

  function trigger() {
    if (shown || checking) return;
    checking = true;
    isUS().then(function (ok) {
      checking = false;
      if (ok) open(); else cleanup();
    });
  }

  // The Pandectes cookie banner is drawn in the browser's top layer, above
  // any z-index, so keep the popup in the space above it while it is open.
  function bannerTop() {
    var host = document.querySelector('pandectes-cmp');
    var box = host && host.shadowRoot && host.shadowRoot.querySelector('dialog');
    if (!box) return null;
    var r = box.getBoundingClientRect();
    var s = getComputedStyle(box);
    if (!r.height || s.display === 'none' || s.visibility === 'hidden') return null;
    return r.top;
  }
  var fitTimer = null;
  function fitAboveBanner() {
    var top = bannerTop();
    root.style.paddingBottom = top === null ? '' : Math.max(12, window.innerHeight - top + 12) + 'px';
  }

  function open() {
    if (shown) return;
    shown = true;
    cleanup();
    hideFor(SHOW_EVERY_DAYS);
    lastFocus = document.activeElement;
    root.hidden = false;
    fitAboveBanner();
    fitTimer = setInterval(fitAboveBanner, 500);
    window.addEventListener('resize', fitAboveBanner);
    var input = root.querySelector('#sg-popup-email');
    setTimeout(function () { input && input.focus({ preventScroll: true }); }, 50);
  }

  function close() {
    root.hidden = true;
    clearInterval(fitTimer);
    window.removeEventListener('resize', fitAboveBanner);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function show(step) {
    root.querySelectorAll('[data-sg-popup-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-sg-popup-step') !== step;
    });
    var first = root.querySelector('[data-sg-popup-step="' + step + '"] input:not([type=hidden]), [data-sg-popup-step="' + step + '"] .sg-popup__title');
    if (first && first.focus) first.focus({ preventScroll: true });
  }

  // Display triggers.
  // Desktop: 6 seconds, 20% scroll, or exit intent (mouse leaves through the top).
  // Mobile: 20 seconds, or exit intent before that. Phones have no mouse, so
  // exit intent is a quick scroll back up after the visitor has scrolled down,
  // the usual move before tapping the address bar or back button.
  var isMobile = window.matchMedia('(max-width: 767px)').matches;
  var timer = setTimeout(trigger, isMobile ? 20000 : 6000);
  var maxY = 0, recent = [];
  function onScroll() {
    var y = window.scrollY, t = Date.now();
    if (isMobile) {
      // Quick flick up: at least 200px upward within the last 300ms, after the
      // visitor has scrolled down at least 400px.
      maxY = Math.max(maxY, y);
      recent.push([y, t]);
      while (recent.length && t - recent[0][1] > 300) recent.shift();
      var highest = Math.max.apply(null, recent.map(function (r) { return r[0]; }));
      if (maxY > 400 && highest - y >= 200) trigger();
    } else {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && y / max >= 0.2) trigger();
    }
  }
  function onMouseOut(e) {
    if (!e.relatedTarget && e.clientY <= 0) trigger();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('mouseout', onMouseOut);
  function cleanup() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onMouseOut);
  }

  root.querySelectorAll('[data-sg-popup-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  function setError(id, message) {
    var el = document.getElementById(id);
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function post(form, body) {
    var button = form.querySelector('.sg-popup__button');
    var status = form.querySelector('.sg-popup__status');
    status.hidden = true;
    button.disabled = true;
    button.textContent = MSG.processing;
    return fetch(root.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (res.ok && data.ok) return data;
          var err = new Error(data.error || 'failed');
          err.code = data.error;
          throw err;
        });
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = button.dataset.label;
      });
  }

  // Step 1: email
  var emailForm = root.querySelector('[data-sg-popup-step="email"]');
  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = emailForm.elements.email;
    var value = input.value.trim();
    var error = value === '' ? MSG.required : (EMAIL_RE.test(value) ? '' : MSG.email);
    setError('sg-popup-email-error', error);
    input.setAttribute('aria-invalid', error ? 'true' : 'false');
    if (error) { input.focus(); return; }
    post(emailForm, { source: 'popup', email: value, website: emailForm.elements.website.value })
      .then(function () {
        email = value;
        hideFor(AFTER_SIGNUP_DAYS);
        show('phone');
      })
      .catch(function (err) {
        if (err.code === 'email') { setError('sg-popup-email-error', MSG.email); input.focus(); return; }
        var status = emailForm.querySelector('.sg-popup__status');
        status.textContent = MSG.failed;
        status.hidden = false;
      });
  });

  // Step 2: phone + SMS consent
  var phoneForm = root.querySelector('[data-sg-popup-step="phone"]');
  phoneForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var phone = phoneForm.elements.phone;
    var consent = phoneForm.elements.smsConsent;
    var digits = phone.value.replace(/\D/g, '');
    var phoneError = digits === '' ? MSG.required : (digits.length < 7 ? MSG.phone : '');
    setError('sg-popup-phone-error', phoneError);
    setError('sg-popup-consent-error', consent.checked ? '' : MSG.consent);
    if (phoneError) { phone.focus(); return; }
    if (!consent.checked) { consent.focus(); return; }
    post(phoneForm, {
      source: 'popup',
      step: 'phone',
      email: email,
      dialCode: phoneForm.elements.dialCode.value,
      phone: phone.value,
      smsConsent: true
    })
      .then(function () { show('done-sms'); })
      .catch(function (err) {
        if (err.code === 'phone') { setError('sg-popup-phone-error', MSG.phone); phone.focus(); return; }
        var status = phoneForm.querySelector('.sg-popup__status');
        status.textContent = MSG.failed;
        status.hidden = false;
      });
  });

  root.querySelector('[data-sg-popup-skip]').addEventListener('click', function () {
    show('done-email');
  });
})();
